import(/* webpackMode: "eager" */ "/home/runner/work/s4a-headless/s4a-headless/apps/headless/src/app/[locale]/error.tsx");
